/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Details_Capability_Reset_DescInputs */



/**
* | output |
* | --- |
* | "A capability override was removed, so the organisation default applies again." |
*
* @param {Audit_Details_Capability_Reset_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_capability_reset_desc = /** @type {((inputs?: Audit_Details_Capability_Reset_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_Capability_Reset_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Eine Berechtigungs-Ausnahme wurde entfernt, damit gilt wieder die Voreinstellung der Organisation.")
	return /** @type {LocalizedString} */ ("A capability override was removed, so the organisation default applies again.")
});